jQuery(function ($) {

  //モーダル
  $('.openModal').on('click', function () {
    var target = $(this).data('modal-link');
    var modal = document.querySelector('.' + target);
    $(modal).fadeIn();
    $('.modalBg').fadeIn();
    $('.mainbiz-gal h3').toggleClass('behind');
  });

  $('.closeModal , .modalBg').on('click', function () {
    $(this).parents('.modal').fadeOut();
  });

  //MVフェードイン
  $(window).on('load', function () {
    $('.js-fade-soon').addClass('fadein');
    $('.js-fade-soon_fast').addClass('fadein');
    $('.js-fade-soon_slow').delay(1500).queue(function () {
      $(this).addClass('fadein').dequeue();
    });
  });

  //コンテンツフェードイン
  $(window).on('scroll', function () {
    $('.js-fadein').each(function () {
      var elemPos = $(this).offset().top,
        scroll = $(window).scrollTop(),
        windowHeight = $(window).height();
      if (scroll > elemPos - windowHeight + 100) {
        $(this).addClass('fadein');
      }
    });
    $('.js-fadein_slow').each(function () {
      var elemPos = $(this).offset().top,
        scroll = $(window).scrollTop(),
        windowHeight = $(window).height();
      if (scroll > elemPos - windowHeight + 100) {
        $(this).delay(500).queue(function () {
          $(this).addClass('fadein').dequeue();
        });
      }
    });
  });

  //ハンバーガーメニュー
  $('.menu-btn').on('click', function () {
    $('.menu-btn').toggleClass('active');
    $('nav').toggleClass('active');
  });

  //トップへ戻る
  $('.totop a').click(function () {
    var speed = 500;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $('body,html').stop().animate({
      scrollTop: position
    }, speed, 'linear');
    return false;
  });

  var fixedTotop = $('.totop'),
    startPosition = 0,
    timeOutId;

  $(window).on('load scroll', function () {
    var scrollValue = $(window).scrollTop();
    var mvValue = $('.mv').height();

    timeOutId = setTimeout(function () {
      if (scrollValue > mvValue) {
        fixedTotop.removeClass('is-hiden');
        fixedTotop.addClass('is-shown');
      } else {
        fixedTotop.addClass('is-hiden');
        fixedTotop.removeClass('is-shown');
      }
    }, 200);
  });

});
